// Mock data for "The Supreme Awakening Collection" landing page + checkout.
// All pricing in INR (Indian Rupees).

export const BUNDLE_NAME = 'The Supreme Awakening Collection';
export const BUNDLE_TAGLINE =
  'Rewire your nervous system, awaken dormant energy, and shift into your highest frequency — in under 10 minutes a day.';

export const BUNDLE_PRICE = 39; // Today's price (USD)
export const BUNDLE_ORIGINAL_PRICE = 197; // Original strikethrough (USD)
export const BUNDLE_SAVINGS = BUNDLE_ORIGINAL_PRICE - BUNDLE_PRICE;
export const BUNDLE_DISCOUNT_PCT = Math.round(
  (BUNDLE_SAVINGS / BUNDLE_ORIGINAL_PRICE) * 100
);

export const PRIMARY_BUY_LINE =
  "Claim lifetime access for a one-time $39 USD — a fraction of a single therapy session, yours forever.";

// Format helper for USD — subtle USD suffix so international buyers know the currency for sure
export const fmt = (n) => `$${Number(n).toLocaleString('en-US')} USD`;

export const modules = [
  {
    id: 'm1',
    tag: 'Module 1',
    accent: 'emerald',
    value: 69,
    title: 'The Core Foundations & Mind-Body Reset',
    subtitle:
      'The essential foundation — everything a beginner needs to build a daily practice and reset the nervous system.',
    items: [
      { title: 'Meditation Mastery' },
      { title: 'Stress-Proof Your Brain' },
      { title: 'Meditation for Beginners' },
      { title: 'Meditainment Relaxation Guided Meditations' },
      { title: "The Meditator's Handbook" },
      { title: 'Foundational Meditations for Beginners' },
    ],
  },
  {
    id: 'm2',
    tag: 'Module 2',
    accent: 'amber',
    value: 64,
    title: 'Energy Awakening & Psychic Activation',
    subtitle:
      'Awaken dormant energy centers, sharpen intuition, and reconnect with the subtle awareness most modern lives keep locked.',
    items: [
      { title: 'Guided Meditations' },
      { title: 'Awaken the Chakras' },
      { title: 'Meditation On Twin Hearts & Pranic Healing' },
      { title: 'Silva Mind Body Healing Program' },
      { title: 'Secret Powers Of Your Mind' },
      { title: 'Opening Your Psychic Abilities' },
    ],
  },
  {
    id: 'm3',
    tag: 'Module 3',
    accent: 'sky',
    value: 64,
    title: 'Advanced Mind Power & Frequency Shifting',
    subtitle:
      'The advanced vault: rewrite subconscious patterns, raise your baseline frequency, and align reality with intention.',
    items: [
      { title: 'Healing Mind System 2.0' },
      { title: 'Masterclass Interview on Meditation' },
      { title: 'Reiki Meditations' },
      { title: 'Complete Mind Power Study Program' },
      { title: 'Mind Power into the 21st Century' },
      { title: 'Raising Your Frequency' },
      { title: 'The Fine Arts of Relaxation & Concentration' },
    ],
  },
];

// 5 checkout order bumps — with itemized lists and USD pricing.
export const orderBumps = [
  {
    id: 'bump1',
    title: 'The Instant Alignment Frequency Pack',
    tagline: 'Reset your baseline vibration in a single 5-minute session.',
    price: 12,
    total: 47,
    items: [
      { title: 'Pineal Gland Activation Audio' },
      { title: 'Pineal Gland Stimulator' },
      { title: 'Instant Advanced Meditation' },
      { title: 'Tibetan Bowl Meditation' },
      { title: '7-Minute Chakra Tune Up' },
      { title: 'The Rapid Path to Eternal Bliss' },
    ],
    checkboxCopy: 'Yes! Add the Instant Alignment Frequency Pack for just $12 USD.',
    badge: 'Popular Add-On',
  },
  {
    id: 'bump2',
    title: 'The Deep Healing & Astral Sleep Collection',
    tagline: 'Trigger deep cellular repair and lucid rest the moment you close your eyes.',
    price: 12,
    total: 57,
    items: [
      { title: 'Astral Projection & Self-Hypnosis' },
      { title: 'Shamanic Dream' },
      { title: 'The Art of Healing' },
      { title: 'The Art of Meditation' },
      { title: 'Find Answers In Your Dreams' },
      { title: 'Telepathy Guide' },
    ],
    checkboxCopy: 'Yes! Add the Deep Healing & Astral Sleep Collection for just $12 USD.',
    badge: 'Bestseller',
  },
  {
    id: 'bump3',
    title: 'The Ultimate Intuition & Quantum Mastery Vault',
    tagline: 'Quantum awareness, intuition, and mind-power mastery — the advanced vault.',
    price: 15,
    total: 97,
    items: [
      { title: 'Chi Power Plus' },
      { title: 'Chi Power Fundamentals' },
      { title: 'Silva Ultramind' },
      { title: 'Silva Intuition System' },
      { title: 'Opening Your Chakras' },
      { title: 'Quantum Mind Power Manual' },
    ],
    checkboxCopy: 'Yes! Add the Ultimate Intuition & Quantum Mastery Vault for just $15 USD.',
    badge: 'Premium Add-On',
  },
  {
    id: 'bump4',
    title: 'The Esoteric Wisdom & Magic Library',
    tagline: 'Ancient hermetic principles, alchemy, and symbolic magic decoded.',
    price: 18,
    total: 77,
    items: [
      { title: 'Christopher Hyatt Collection' },
      { title: 'Creative Visualization Meditations' },
      { title: 'Essential Reiki' },
      { title: 'Initiations of Magic' },
      { title: 'Mentalphysics' },
      { title: "Merlin's Magic: Angel Helpers" },
      { title: 'Ninja Mind Control' },
      { title: 'Magical Path Working' },
      { title: 'Secret of the Golden Flower' },
    ],
    checkboxCopy: 'Yes! Add the Esoteric Wisdom & Magic Library for just $18 USD.',
    badge: 'Rare Add-On',
  },
  {
    id: 'bump5',
    title: 'The Spirit Guides & Akashic Discovery Pack',
    tagline: 'Open a direct channel to guidance, records, and the higher self.',
    price: 15,
    total: 77,
    items: [
      { title: 'Sananda Mystery School' },
      { title: 'Connecting With Your Guide' },
      { title: 'Akashic Records Guided Meditation' },
      { title: 'Activation of DNA: Code Of Life' },
      { title: 'Imaginarium' },
      { title: 'Immunity' },
      { title: 'Sacred Chants' },
      { title: 'Exploring Your Past Lives' },
      { title: 'Meet Your Spirit Guides' },
      { title: 'The Power of Om' },
    ],
    checkboxCopy: 'Yes! Add the Spirit Guides & Akashic Discovery Pack for just $15 USD.',
    badge: 'Limited Add-On',
  },
];

// Bundled add-on deals to increase AOV.
export const ADDON_BUNDLES = {
  any3: {
    id: 'any3',
    label: 'Any 3 Add-Ons',
    price: 27,
    count: 3,
    // "Was" reference = 3 cheapest add-ons summed
    was: 12 + 12 + 15, // 39
    savingsLabel: 'Save up to $18 USD',
    subline: 'Pick any 3 add-ons of your choice at a special bundled price.',
  },
  all5: {
    id: 'all5',
    label: 'All 5 Add-Ons (Best Value)',
    price: 49,
    count: 5,
    was: 12 + 12 + 15 + 18 + 15, // 72
    savingsLabel: 'Save $23 USD',
    subline: "Unlock every single add-on. Nothing left behind. Best per-track value.",
  },
};

export const meditationTestimonials = [
  {
    name: 'Sophia R.',
    role: 'Product Designer, London',
    photo:
      'https://images.pexels.com/photos/9159272/pexels-photo-9159272.jpeg?w=96&h=96&fit=crop&crop=faces&auto=compress',
    text:
      'The sleep tracks re-set my nights within a week. I now fall asleep in under 10 minutes after years of insomnia. Worth 100x the price.',
  },
  {
    name: 'David K.',
    role: 'Entrepreneur, Toronto',
    photo:
      'https://images.unsplash.com/photo-1573999842765-26f179ec3979?w=96&h=96&fit=crop&crop=faces&auto=format&q=70',
    text:
      'The frequency and subconscious tracks healed a 10-year anxiety pattern and doubled my deep-work hours. This is the real thing.',
  },
  {
    name: 'Ines M.',
    role: 'Yoga Teacher, Barcelona',
    photo:
      'https://images.unsplash.com/photo-1617009762269-c062aaf6b3a0?w=96&h=96&fit=crop&crop=faces&auto=format&q=70',
    text:
      'The energy activation module alone is worth hundreds. Getting the entire library for $39 USD is an absolute steal.',
  },
];

export const meditationFaqs = [
  {
    q: 'How do I access all the files after payment?',
    a: 'Immediately after payment you receive direct lifetime download links in your email. Everything is instantly accessible on any device — no waiting, no shipping.',
  },
  {
    q: 'Is this suitable for complete beginners?',
    a: "Absolutely. Module 1 is designed specifically for absolute novices — starting from just 5 minutes a day — while the advanced modules take you deeper as you grow.",
  },
  {
    q: 'What devices and formats does the library work on?',
    a: 'Universal MP3 audio and PDF format. Compatible with all phones, tablets, and laptops. Stream directly or download and keep forever.',
  },
  {
    q: 'How long do I have access?',
    a: 'Lifetime access. Once downloaded, everything is yours forever. No monthly subscription. No hidden charges. No renewals.',
  },
  {
    q: 'How is the launch price valid for only 50 people?',
    a: 'To keep quality high and support responsive, we reserve the $39 USD launch price for the first 50 action-takers of each cohort. After that the price returns to $197 USD.',
  },
];
